import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { DataService } from '../services/data.service';
import { SupabaseService } from '../services/supabase.service';
import { TenantService } from '../services/tenant.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private readonly router: Router,
    private sb: SupabaseService,
    private tenantService: TenantService,

    private dataService: DataService
  ) {}

  // return true if user is logged in and false if not, use auth.isAuthenticated$ observable to see if user is logged in
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.sb._currentUser.pipe(
      tap((loggedIn) => {
        console.log('loggedIn', loggedIn);
        if (!loggedIn) {
          this.router.navigate(['/login']);
        }
      })
    );
  }
}
